<template>
  <div id="toReconcileExpensesComponent">
    <v-layout>
      <page-title
        :heading="heading"
        :subheading="subheading"
        :icon="icon"
        class="mr-5"
      >
      </page-title>
      <h2 class="ml-5 mt-4 subtitle-1">
        {{ $t('conciliation.period') }}: {{ dateFormat(startDate) }} -
        {{ dateFormat(endDate) }}
      </h2>
    </v-layout>
    <v-container class="py-0 my-0">
      <v-flex class="text-xs-right py-0 my-0">
        <v-btn
          color="primary"
          round
          outline
          :loading="downloadLoading"
          @click="downloadXls()"
        >
          {{ $t('conciliation.download') }}
          <v-icon right>cloud_download</v-icon>
        </v-btn>
      </v-flex>
      <v-flex class="text-xs-right py-0 my-0">
        <v-dialog persistent v-model="dialog" max-width="700px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" round outline v-on="on">
              <v-icon left>filter_list</v-icon>
              {{ $t('general.filter') }}
            </v-btn>
          </template>
          <v-card>
            <v-toolbar flat>
              <h2 class="font-weight-black primary--text mb-0">
                {{ $t('general.filter') }}
              </h2>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-md>
                <v-form lazy-validation ref="form" v-model="valid">
                  <v-layout>
                    <v-flex xs6>
                      <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            required
                            :rules="rules.required"
                            :error-messages="errors.startDate"
                            v-model="startDate"
                            :label="$t('general.startDate')"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          :max="endDate"
                          color="primary"
                          v-model="startDate"
                          @input="menu = false"
                          :locale="$t('history.local')"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs6>
                      <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            required
                            :rules="rules.required"
                            v-model="endDate"
                            :error-messages="errors.endDate"
                            :label="$t('general.endDate')"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          color="primary"
                          v-model="endDate"
                          @input="menu2 = false"
                          :max="new Date().toISOString().substr(0, 10)"
                          :min="startDate"
                          :locale="$t('history.local')"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                  <v-layout
                    v-if="
                      userLogged.roles && userLogged.roles[0].name === 'ADMIN'
                    "
                  >
                    <v-flex>
                      <v-switch
                        color="primary"
                        v-model="switchAllEmployees"
                        :label="
                          switchAllEmployees
                            ? $t('expenseDetailEmployee.allEmployees')
                            : $t('expenseDetailEmployee.perEmployee')
                        "
                      ></v-switch>
                      <v-autocomplete
                        v-if="!switchAllEmployees"
                        v-model="selectedEmployee"
                        item-text="name"
                        item-value="id"
                        persistent-hint
                        :rules="rules.required"
                        :items="employees"
                        :label="$t('expenseDetailEmployee.employee')"
                      >
                      </v-autocomplete>
                    </v-flex>
                  </v-layout>
                  <v-layout v-if="hasPermission()">
                    <v-flex xs8>
                      <v-radio-group
                        v-model="filterActiveRadio"
                        column
                        :label="$t('conciliation.searchType')"
                        label-size="sm"
                      >
                        <v-radio
                          v-for="n in 2"
                          :key="n"
                          :label="`${
                            n === 1
                              ? $t('conciliation.filter.reconciledExpenses')
                              : $t('general.rejected')
                          }`"
                          :value="n"
                        ></v-radio>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary darken-1" round flat @click="close">
                {{ $t('general.close') }}
              </v-btn>
              <v-btn
                :loading="loading"
                :disabled="loading"
                color="primary"
                round
                depressed
                @click="send"
              >
                {{ $t('general.submit') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <b-row>
        <!-- Monto TC -->
        <b-col class="px-2" col-md-6 col-xl-4>
          <b-card class="pa-0 widget-content yellow-block">
            <div class="">
              <div>
                <div class="widget-heading text-center">
                  {{ $t('conciliation.tCAmount') }}:
                </div>
                <div class=" text-center" v-if="loading">
                  <v-progress-circular
                    indeterminate
                    size="20"
                  ></v-progress-circular>
                </div>
                <div class="widget-data-filter " v-else>
                  <h2><b>{{ allAmount | formatCurrency }}</b></h2>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
        <!-- Monto conciliado Bluespend -->
        <b-col class="px-2" col-md-6 col-xl-4>
          <b-card class="pa-0 widget-content green-block">
            <div class="">
              <div>
                <div class="widget-heading text-center">
                  {{ $t('conciliation.bluespendReconciledAmount') }}:
                </div>
                <div class="text-center" v-if="loading">
                  <v-progress-circular
                    indeterminate
                    size="20"
                  ></v-progress-circular>
                </div>
                <div class="widget-data-filter " v-else>
                  <h2><b>{{ consiliateAmount | formatCurrency }}</b></h2>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
        <!-- Monto Faltante -->
        <b-col class="px-2" col-md-6 col-xl-4>
          <b-card class="pa-0 widget-content red-block">
            <div class="">
              <div>
                <div class="widget-heading text-center">
                  {{ $t('conciliation.missingAmount') }}:
                </div>
                <div class="text-center" v-if="loading">
                  <v-progress-circular
                    indeterminate
                    size="20"
                  ></v-progress-circular>
                </div>
                <div class="widget-data-filter " v-else>
                  <h2><b>{{ missingAmount | formatCurrency }}</b></h2>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
        <!-- Monto Excluidos -->
        <b-col class="px-2" col-md-6 col-xl-4>
          <b-card class="pa-0 widget-content blue-block">
            <div class="">
              <div>
                <div class="widget-heading text-center">
                  {{ $t('conciliation.excludedAmount') }}:
                </div>
                <div class="text-center" v-if="loading">
                  <v-progress-circular
                    indeterminate
                    size="20"
                  ></v-progress-circular>
                </div>
                <div class="widget-data-filter " v-else>
                  <h2><b>{{ excludedAmount | formatCurrency }}</b></h2>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
        <!-- Filtro Empleados -->
        <b-col
          class="px-2"
          col-md-12
          col-xl-12
          v-if="
            userLogged.roles &&
            userLogged.roles[0].name === 'ADMIN' &&
            selectedEmployee
          "
        >
          <b-card class="ma-0 pa-0 widget-content bg-info">
            <div class="text-white ma-0 pa-0">
              <div class="ma-0 pa-0">
                <div class="text-white text-center" v-if="!selectedEmployee">
                  <v-progress-circular
                    indeterminate
                    size="20"
                  ></v-progress-circular>
                </div>
                <div class="text-white ma-0 pa-0" v-else>
                  <v-autocomplete
                    v-model="selectedEmployee"
                    item-text="name"
                    item-value="id"
                    :rules="rules.required"
                    :items="employees"
                    class="select-employee"
                    @change="selectedEmployeeChange()"
                  >
                    <template #selection="{ item }">
                      <span class="select-employee text-white text-truncate">{{
                        item.name
                      }}</span>
                    </template>
                  </v-autocomplete>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <v-spacer class="my-3"></v-spacer>
      <v-flex>
        <v-toolbar flat color="bg-sidebar" dark>
          <h2 class="my-0" v-if="filterActiveRadio === 1">
            {{ $t('conciliation.status.conciliated') }}
          </h2>
          <h2 class="my-0" v-else>{{ $t('conciliation.status.missing') }}</h2>
          <v-spacer></v-spacer>
          <v-text-field
            color="light"
            v-model="search"
            :label="$t('general.search')"
            clearable
            append-outer-icon="search"
          >
          </v-text-field>
        </v-toolbar>
        <v-data-table
          :search="search"
          class="elevation-2"
          :headers="headers"
          :items="conciliations"
          :loading="loadingItems"
          :rows-per-page-items="[10, 15, 25]"
          :pagination.sync="pagination"
        >
          <template v-slot:headers="props">
            <tr class="bg-heavy-rain">
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column',
                  header.sortable ? 'sortable' : '',
                  pagination.descending ? 'desc' : 'asc',
                  header.value === pagination.sortBy ? 'active' : '',
                ]"
                @click="changeSort(header.value)"
              >
                <h2 class="font-weight-black primary--text mb-0">
                  <v-icon small class="primary--text" v-if="header.sortable"
                    >arrow_upward</v-icon
                  >
                  {{ header.text }}
                </h2>
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr
              class=""
              @click="props.expanded = !props.expanded"
            >
              <td class="font-weight-black" style="max-width: 20px">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="!props.expanded" v-on="on" color="primary">
                      mdi-chevron-down
                    </v-icon>
                    <v-icon v-else v-on="on" color="primary">
                      mdi-chevron-up
                    </v-icon>
                  </template>
                  <span>
                    {{
                      !props.expanded
                        ? $t('general.extend')
                        : $t('general.collapse')
                    }}
                  </span>
                </v-tooltip>
              </td>
              <td class="text-sm-center">{{ props.item.id }}</td>
              <td width="60px">{{ props.item.user.name }}</td>
              <td class="text-sm-center">
                {{ props.item.transaction_number }}
              </td>
              <td class="text-sm-center">{{ props.item.description }}</td>
              <td class="text-sm-center">{{ props.item.supplier_name }}</td>
              <td class="text-sm-center">
                {{ props.item.amount | formatCurrency }}
              </td>
              <td class="text-sm-left">
                {{
                  props.item && props.item.expense_item_id
                    ? props.item.expense_item_id
                    : $t('conciliation.notConciliated')
                }}
              </td>
              <td class="text-sm-left">
                {{
                  props.item && props.item.consiliate_date
                    ? props.item.consiliate_date
                    : $t('general.noDefined')
                }}
              </td>
            </tr>
          </template>
          <template v-slot:expand="props">
            <v-card flat>
              <v-layout>
                <v-layout v-if="!props.item.item">
                  <v-flex xs12>
                    <p class="text-sm-left ml-4">{{ $t('history.noItem') }}</p>
                  </v-flex>
                </v-layout>
                <v-layout v-else>
                  <v-flex xs12>
                    <table width="100%">
                      <thead>
                        <th class="text-sm-center font-weight-black">#</th>
                        <th class="text-sm-center font-weight-black">UUID</th>
                        <th class="text-sm-center font-weight-black">
                          {{ $t('general.description') }}
                        </th>
                        <th class="text-sm-center font-weight-black">
                          {{ $t('general.subtotal') }}
                        </th>
                        <th class="text-sm-center font-weight-black">
                          {{ $t('general.total') }}
                        </th>
                        <th class="text-sm-center font-weight-black">
                          {{ $t('general.comment') }}
                        </th>
                        <th class="text-sm-center font-weight-black">
                          {{ $t('general.actions') }}
                        </th>
                      </thead>
                      <tr>
                        <td class="text-sm-center">{{ props.item.item.id }}</td>
                        <td class="text-sm-center">
                          {{ props.item.item.uuid }}
                        </td>
                        <td class="text-sm-center">
                          {{ props.item.item.description }}
                        </td>
                        <td class="text-sm-center">
                          {{ props.item.item.subtotal | formatCurrency }}
                        </td>
                        <td class="text-sm-center">
                          {{ props.item.item.total | formatCurrency }}
                        </td>
                        <td class="text-sm-center">
                          {{ props.item.item.comment }}
                        </td>
                        <td class="text-sm-center">
                          <v-btn
                            v-if="props.item.item.gst_receipt_types_id === 2"
                            small
                            outline
                            round
                            color="primary"
                            icon
                            @click="viewExpenses(props.item.item)"
                          >
                            <v-icon small>search</v-icon>
                          </v-btn>
                          <v-btn
                            v-else
                            small
                            outline
                            round
                            color="primary"
                            icon
                            @click="viewExpenses(props.item.item)"
                          >
                            <v-icon small>search</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                      <tr v-if="props.item.item.tip">
                        <td colspan="3"></td>
                        <td colspan="4">
                          Propina:
                          {{
                            new Intl.NumberFormat('es-MX', {
                              style: 'currency',
                              currency: 'MXN',
                              minimumFractionDigits: 2,
                            }).format(props.item.item.tip.amount)
                          }}
                        </td>
                      </tr>
                    </table>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-card>
          </template>
        </v-data-table>
      </v-flex>
      <v-dialog v-model="dialogItem" scrollable max-width="900px" persistent>
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('workflowValidation.item') }}{{ editedItem.id }}
              <span>
                (
                {{
                  editedItem.gst_receipt_types_id === 1 ? 'Fiscal' : 'No Fiscal'
                }}
                )</span
              >
            </h2>
          </v-toolbar>
          <template v-if="editedItem.gst_receipt_types_id === 1">
            <v-card-text class="text-center" v-if="!cfdiHtml">
              <v-progress-circular
                class="my-5"
                indeterminate
                size="70"
                color="primary"
              />
            </v-card-text>
            <v-card-text v-else>
              <iframe
                name="cfdi"
                :srcdoc="cfdiHtml"
                style="width: 845px; height: 1200px; border: 0"
              >
              </iframe>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 md6>
                    <v-text-field
                      :label="$t('general.category')"
                      disabled
                      outline
                      :value="
                        editedItem.gst_categories.name
                          ? editedItem.gst_categories.name
                          : ''
                      "
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea
                      :label="$t('general.comment')"
                      disabled
                      outline
                      v-model="editedItem.comment"
                    >
                    </v-textarea>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </template>
          <template v-if="editedItem.gst_receipt_types_id === 2">
            <v-card-text class="text-center" v-if="loadItem">
              <v-progress-circular
                class="my-5"
                indeterminate
                size="70"
                color="primary"
              />
            </v-card-text>
            <v-card-text v-else>
              <v-container grid-list-md>
                <v-layout row wrap>
                  <v-flex layout row wrap v-bind:class="{ xs6: dataURL }">
                    <v-flex xs6>
                      <p class="primary--text mb-0 text-sm-left">
                        <strong>{{ $t('general.date') }}</strong>
                      </p>
                      <p class="text-sm-left">{{ editedItem.date }}</p>
                    </v-flex>
                    <v-flex xs6>
                      <p class="primary--text mb-0 text-sm-left">
                        <strong>{{ $t('general.category') }}</strong>
                      </p>
                      <p class="text-sm-left">
                        {{
                          editedItem.gst_categories
                            ? editedItem.gst_categories.name
                            : ''
                        }}
                      </p>
                    </v-flex>
                    <v-flex xs6>
                      <p class="primary--text mb-0 text-sm-left">
                        <strong>{{ $t('general.country') }}</strong>
                      </p>
                      <p class="text-sm-justify">
                        {{
                          editedItem.country && editedItem.country.descripcion
                        }}
                      </p>
                    </v-flex>
                    <v-flex xs12>
                      <p class="primary--text mb-0 text-sm-left">
                        <strong>{{ $t('general.description') }}</strong>
                      </p>
                      <p class="text-sm-left">
                        {{ editedItem.description && editedItem.description }}
                      </p>
                    </v-flex>
                    <v-flex xs6>
                      <p class="primary--text mb-0 text-sm-left">
                        <strong>{{ $t('general.currency') }}</strong>
                      </p>
                      <p class="text-sm-left">
                        {{
                          editedItem.currency && editedItem.currency.c_Moneda
                        }}
                        -
                        {{
                          editedItem.currency && editedItem.currency.descripcion
                        }}
                      </p>
                    </v-flex>
                    <v-flex xs6>
                      <p class="primary--text mb-0 text-sm-left">
                        <strong>{{ $t('general.exchangeRate') }}</strong>
                      </p>
                      <p class="text-sm-left">{{ editedItem.exchange }}</p>
                    </v-flex>
                    <v-flex xs6>
                      <p class="primary--text mb-0 text-sm-left">
                        <strong>{{ $t('general.subtotal') }}</strong>
                      </p>
                      <p class="text-sm-left">
                        ${{ editedItem.subtotal }}
                        {{ editedItem.currency.c_Moneda }}
                      </p>
                    </v-flex>
                    <v-flex xs6>
                      <p class="primary--text mb-0 text-sm-left">
                        <strong>{{ $t('general.total') }}</strong>
                      </p>
                      <p class="text-sm-left">
                        ${{ editedItem.total }}
                        {{ editedItem.currency.c_Moneda }}
                      </p>
                    </v-flex>
                    <v-flex xs6>
                      <p class="primary--text mb-0 text-sm-left">
                        <strong>{{ $t('general.formaPago') }}</strong>
                      </p>
                      <p class="text-sm-left">
                        {{
                          editedItem.sat_forma_pago &&
                          editedItem.sat_forma_pago.descripcion
                        }}
                      </p>
                    </v-flex>
                    <v-flex xs6>
                      <p class="primary--text mb-0 text-sm-left">
                        <strong>{{ $t('general.folioRef') }}</strong>
                      </p>
                      <p class="text-sm-left">{{ editedItem.folio }}</p>
                    </v-flex>
                    <v-flex xs6>
                      <p class="primary--text mb-0 text-sm-left">
                        <strong>{{ $t('general.comment') }}</strong>
                      </p>
                      <p class="text-sm-justify">{{ editedItem.comment }}</p>
                    </v-flex>
                  </v-flex>
                  <v-flex xs6 layout v-if="dataURL">
                    <v-flex xs12>
                      <a v-if="!isPDF(dataURL)" @click="openPDF()">
                        <zoom-on-hover :img-normal="dataURL"></zoom-on-hover>
                      </a>
                      <v-btn
                        block
                        v-if="isPDF(dataURL)"
                        @click="openPDF()"
                        color="primary"
                        depressed
                      >
                        <v-icon left>insert_drive_file</v-icon>
                        {{ $t('expenseItems.watchFile') }}
                      </v-btn>
                      <iframe
                        v-if="isPDF(dataURL)"
                        :src="dataURL"
                        frameborder="0"
                        width="100%"
                        height="400px"
                      ></iframe>
                    </v-flex>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </template>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              flat
              round
              class="white--text"
              depressed
              @click="close"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <!-- <v-btn
            color="success darken-1"
            round
            flat
            :loading="loadingXML"
            @click="downloadXML"
          >
            {{$t('general.downloadXML')}}
          </v-btn>
          <v-btn :disabled="!cfdiHtml" round flat color="primary" @click="sendToPrint()"><v-icon left>print</v-icon> {{$t('general.print')}}</v-btn> -->
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
/* eslint-disable */
import { library } from '@fortawesome/fontawesome-svg-core'
import vue2Dropzone from 'vue2-dropzone'

import { faHandshake, faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faHandshake, faSignOutAlt)
export default {
  name: 'reconciledExpensesComponent',
  components: {
    vueDropzone: vue2Dropzone,
    'font-awesome-icon': FontAwesomeIcon,
  },
  data() {
    return {
      totalAmounts: [],
      allAmount: 0,
      consiliateAmount: 0,
      excludedAmount: 0,
      missingAmount: 0,
      status: 'CONSILIATE',
      dataURL: null,
      cfdiHtml: null,
      valid: true,
      errors: {},
      loadingItems: false,
      menu: false,
      menu2: false,
      switchAllEmployees: true,
      employees: [],
      startDate: new Date().toISOString().substr(0, 10),
      endDate: new Date().toISOString().substr(0, 10),
      downloadLoading: false,
      search: '',
      loading: false,
      filterActiveRadio: 1,
      userLogged: {},
      selectedEmployee: null,
      dialog: false,
      loadTable: false,
      dialogItem: false,
      loadItem: false,
      editedItem: {
        gst_categories: {
          name: '',
        },
        receipt_type: {
          name: '',
        },
      },
      conciliations: [],
      pagination: {
        sortBy: 'id',
        descending: true,
        page: 1,
        rowsPerPage: 15,
        totalItems: 0,
      },
    }
  },
  created() {
    this.getLogged()
  },
  watch: {
    '$store.state.userLogged'() {
      this.getLogged()
    },
    switchAllEmployees(value) {
      if (value) {
        this.selectedEmployee = null
        this.filter_by = 'company'
      } else {
        this.filter_by = 'user'
      }
    },
  },
  computed: {
    rules() {
      return this.$validationRules()
    },
    heading() {
      return this.$t('conciliation.titleReconciled')
    },
    subheading() {
      return ''
    },
    icon() {
      return 'fa fa-handshake fa-fw icon-color'
    },
    headers() {
      return [
        {
          text: '',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('conciliation.amexExpenseNo'),
          align: 'center',
          value: 'id',
          sortable: true,
        },
        {
          text: this.$t('general.name'),
          align: 'center',
          value: 'user.name',
          sortable: true,
        },
        {
          text: this.$t('conciliation.transactionNo'),
          align: 'center',
          value: 'transaction_number',
          sortable: true,
        },
        {
          text: this.$t('conciliation.description'),
          align: 'center',
          value: 'description',
          sortable: true,
        },
        {
          text: this.$t('conciliation.beneficiary'),
          align: 'center',
          value: 'supplier_name',
          sortable: true,
        },
        {
          text: this.$t('conciliation.amount'),
          align: 'center',
          value: 'amount',
          sortable: true,
        },
        {
          text: this.$t('conciliation.conciliedExpense'),
          align: 'center',
          value: 'expense_item_id',
          sortable: true,
        },
        {
          text: this.$t('conciliation.conciliedDate'),
          align: 'center',
          value: 'date',
          sortable: true,
        },
      ]
    },
  },
  methods: {
    hasPermission() {
      if (this.userLogged.roles[0].name === 'ADMIN') {
        return true
      } else {
        return false
      }
    },
    filterAmounts() {
      this.allAmount = this.totalAmounts.all
      this.consiliateAmount = this.totalAmounts.consiliate
      this.excludedAmount = this.totalAmounts.excluded
      this.missingAmount = this.totalAmounts.null
    },
    calculateTotals() {
      this.loading = true
      let userId = null
      if (this.userLogged.roles && this.userLogged.roles[0].name === 'ADMIN') {
        userId = this.selectedEmployee
      } else if (
        this.userLogged.roles &&
        this.userLogged.roles[0].name === 'EMPLOYEE'
      ) {
        userId = this.userLogged.id
      }
      this.$emit('calculateTotals', {
        user_id: userId,
        startDate: this.startDate,
        endDate: this.endDate,
        context: this,
      })
    },
    getLogged() {
      let current = new Date()
      let before = new Date().setDate(current.getDate() - 30)
      let dateStart = new Date(before).toISOString().substr(0, 10)
      this.startDate = dateStart
      if (this.$store.state.userLogged.company) {
        this.userLogged = this.$store.state.userLogged
        this.get()
        this.getEmployees()
        this.calculateTotals()
      }
    },
    selectedEmployeeChange() {
      this.get()
      this.calculateTotals()
    },
    changeSort(header) {
      if (header.sortable) {
        if (this.pagination.sortBy === header.value) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.descending = false
        }
        this.pagination.sortBy = header.value
      } else {
        this.pagination.sortBy = ''
      }
    },
    close() {
      this.dialog = false
      this.dialogItem = false
      this.loadingItems = false
    },
    send() {
      this.get()
      this.calculateTotals()
      this.dialog = false
    },
    get() {
      this.loadingItems = true
      if (this.filterActiveRadio === 3) {
        this.getSecond()
      }
      if (this.userLogged.roles && this.userLogged.roles[0].name === 'ADMIN') {
        this.getEmployees()
        this.$emit('get', {
          context: this,
          userId: this.selectedEmployee,
          petty_cash:
            this.filterActiveRadio === 3 ? this.filterActiveRadio : null,
          filterActiveRadio: this.filterActiveRadio,
        })
      } else if (
        this.userLogged.roles &&
        this.userLogged.roles[0].name === 'EMPLOYEE'
      ) {
        this.$emit('get', {
          context: this,
          userId: this.userLogged.id,
          petty_cash:
            this.filterActiveRadio === 3 ? this.filterActiveRadio : null,
          filterActiveRadio: this.filterActiveRadio,
        })
      }
    },
    getSecond() {
      this.activeSecondRequest = true
      this.$emit('get', {
        context: this,
        userId:
          this.userLogged.roles && this.userLogged.roles[0].name === 'ADMIN'
            ? this.selectedEmployee
            : this.userLogged.id,
        petty_cash: null,
        filterActiveRadio: this.filterActiveRadio,
      })
    },
    getEmployees() {
      this.companyId = this.userLogged.company[0].id
      this.$store.dispatch('expenseDetailEmployee/getCompanyEmployee', {
        event: {
          context: this,
          item: {
            companyId: this.companyId,
          },
        },
      })
    },
    viewExpenses(item) {
      this.editedItem = item
      this.loadItem = true
      this.dialogItem = true
      this.$store.dispatch('expensesItems/getItem', {
        event: {
          id: item.id,
          context: this,
        },
      })
    },
    dateFormat(date) {
      let formatted = date.replace(/-/g, '/')
      return formatted
    },
    downloadXls() {
      if (this.userLogged.roles && this.userLogged.roles[0].name === 'ADMIN') {
        this.$emit('get', {
          context: this,
          type: 'download',
          status: this.status,
          userId: this.selectedEmployee,
          startDate: this.startDate,
          endDate: this.endDate,
        })
      } else if (
        this.userLogged.roles &&
        this.userLogged.roles[0].name === 'EMPLOYEE'
      ) {
        this.$emit('get', {
          context: this,
          type: 'download',
          userId: this.userLogged.id,
          startDate: this.startDate,
          endDate: this.endDate,
        })
      }
    },
    isPDF(data) {
      if (data !== null) {
        let type = data.slice(data.indexOf('/') + 1, data.indexOf(';'))
        if (type === 'pdf') {
          return true
        } else {
          return false
        }
      }
    },
    openPDF() {
      var tab = window.open()
      tab.document.write(
        '<body style="margin: 0;"> <iframe src="' +
          this.dataURL +
          '" frameborder="0" style="margin: 0; padding: 0; border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;"</iframe></body>'
      )
    },
  },
}
</script>

<style scoped>
.yellow-block {
  background-color: #F8E9A1 !important;
}
.blue-block{
  background-color: #D8E8F8 !important;
}
.green-block{
  background-color: #B2E8D1 !important;
}
.red-block{
  background-color: #F4C7C3 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/reconciledExpenses.component.vue